import axios from "axios";

function buildHeaders(config = {}) {
    const headers = {
        "Content-Type": config.contentType || "text/plain; charset=utf-8",
    };

    if (config.authHeader) {
        const separatorIndex = config.authHeader.indexOf(":");
        if (separatorIndex > 0) {
            headers[config.authHeader.slice(0, separatorIndex).trim()] = config.authHeader.slice(separatorIndex + 1).trim();
        } else {
            headers.Authorization = config.authHeader;
        }
    }

    return headers;
}

export async function postText(url, text = "", config = {}, retry = true) {
    try {
        return await axios.post(url, text, {
            headers: buildHeaders(config),
            responseType: "text",
            transformResponse: response => response,
        });
    } catch (err) {
        if (retry) {
            return postText(url, text, config, false);
        }

        throw err;
    }
}

export function requireUrl(url, label = "Endpoint URL") {
    if (!url || !url.trim()) {
        throw new Error(`${label} is required.`);
    }

    return url.trim();
}
